package mainmenu

import auth.ApiUserStore
import auth.FeatureFlagStore
import auth.Features
import data.users.profile.MyProfileStore
import dev.fritz2.core.RenderContext
import koin.withKoin
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.map
import localization.TL
import localization.Translation
import map.Cards
import model.MyProfile
import model.fullName
import model.profilePhoto
import routing.MainController
import theme.FormationIcons
import theme.FormationUIIcons
import twcomponents.twGhostButton
import twcomponents.twLargeIconButtonNeutralRounded
import twcomponents.twPageHeaderClose
import utils.ToggleStore
import utils.handleFunctions

class AccountMenuToggleStore : ToggleStore(false)

fun RenderContext.accountMenu() {
    withKoin {
        val accountMenuToggleStore: AccountMenuToggleStore = get()
        val routerStore: RouterStore = get()
        val myProfileStore: MyProfileStore = get()
        val featureFlagStore: FeatureFlagStore = get()
        val apiUserStore: ApiUserStore = get()
        val mainController: MainController = get()
        val translation: Translation = get()

        // Sign in / Sign up button
        // When signed in:
        // profile picture which opens -> menu to go to:
        // profile
        // settings
        // sharing
        // notifications...
        // and logout button
        accountMenuToggleStore.data.render { show ->
            div(
                baseClass = "flex flex-col gap-1 w-full md:w-120 md:min-w-100 h-min min-h-min z-[1020] md:z-[1009] absolute top-0 md:top-4 md:right-4 md:relative rounded-b-2xl md:rounded-2xl bg-formationWhite transition-all duration-300 ease-in-out shadow-2xl",
                id = searchMenuContainerId,
            ) {
                if (!show) {
                    // Sign in / Profile-picture button that toggles AccountMenu
                    twLargeIconButtonNeutralRounded(icon = FormationUIIcons.Grid) {
                        clicks handledBy {
                            accountMenuToggleStore.update(true)
                        }
                    }
                } else {

                    twPageHeaderClose(
                        additionalBackButtonHandler = handleFunctions {
                            accountMenuToggleStore.update(false)
                        },
                    ) {
                        twGhostButton(
                            text = TL.CardMyUser.SETTINGS,
                            icon = FormationIcons.Gear,
                        ) {
                            clicks handledBy {
                                routerStore.addOrReplaceRoute(Pages.UserSettings.route)
                            }
                        }
                    }
                    combine(apiUserStore.data, featureFlagStore.data) { a, f -> Pair(a.apiUser, f) }.render { (apiUser, features) ->
                        val isNotAnonymous = apiUser?.isAnonymous == false
                        val signUp = features[Features.EnableSignUpButton] == true
                        val sharing = features[Features.DisableLocationSharing] == false

                        if (isNotAnonymous) {
                            // YOUR PROFILE
                            myProfileStore.map(MyProfile.profilePhoto()).data.render { profilePhoto ->
                                mainMenuButton(
                                    profilePicture = profilePhoto?.href,
                                    icon = { FormationIcons.UserAlt.icon },
                                    subtitle = translation[TL.MainMenu.PROFILE_SUBTITLE],
                                    titleLiteral = myProfileStore.map(MyProfile.fullName()).data.map { name ->
                                        translation.getString(
                                            TL.MainMenu.PROFILE,
                                            mapOf("name" to name),
                                        )
                                    },
                                    destinations = listOf(Pages.MyProfile),
                                )
                            }
                            if (sharing) {
                                // LOCATION SHARING
                                mainMenuButton(
                                    icon = { FormationIcons.SharingOn.icon },
                                    title = TL.MainMenu.LOCATION_SHARING,
                                    subtitle = translation[TL.MainMenu.LOCATION_SHARING_SUBTITLE],
                                    destinations = listOf(Pages.Map, Cards.Sharing),
                                )
                            }

                            // LOGOUT
                            mainMenuButton(
                                icon = { FormationIcons.Logout.icon },
                                title = TL.MainMenu.LOGOUT,
                                subtitle = translation[TL.MainMenu.LOGOUT_SUBTITLE],
                                destinations = listOf(Pages.SignOut),
                            )
                        } else {
                            // LOGIN
                            mainMenuButton(
                                icon = { FormationIcons.Login.icon },
                                title = TL.MainMenu.LOGIN,
                                subtitle = translation[TL.MainMenu.LOGIN_SUBTITLE],
                                clickHandlers = listOf(mainController.logoutWithParams),
                                destinations = listOf(Pages.Login),
                            )
                            // In-App LOGIN
//                                val loginToggle = ToggleStore(false)
//                                inAppLoginPopup(loginToggle)
//
//                                mainMenuButton(
//                                    icon = { FormationIcons.Login.icon },
//                                    titleLiteral = flowOf("in-app login"),
//                                    subtitle = translation[TL.MainMenu.LOGIN_SUBTITLE],
//                                    clickHandlers = listOf(
//                                        SimpleHandler { toggle, _ ->
//                                            toggle handledBy {
//                                                loginToggle.update(true)
//                                            }
//                                        },
//                                    ),
//                                )
                            if (signUp) {
                                // SIGN UP
                                mainMenuButton(
                                    icon = { editAlt },
                                    title = TL.MainMenu.SIGN_UP,
                                    subtitle = translation[TL.MainMenu.SIGN_UP_SUBTITLE],
                                    clickHandlers = listOf(mainController.goToSignUp),
                                    destinations = listOf(Pages.SignUp),
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}
